define('home/views/AnonHomepageView',[
    'jquery',
    'underscore',
    'backbone-marionette',

    'core/constants/exploreModuleConstants',

    'home/mixins/withSubviews',
    'home/views/HomepageMarketingView',
    'home/views/AnonHomepageOverlayView',
    'home/views/ExploreChannelGroupsView',
    'home/views/MotdAlertView',
    'home/templates/anonHomepage',
], function (
    $,
    _,
    Marionette,

    exploreModuleConstants,

    withSubviews,
    HomepageMarketingView,
    AnonHomepageOverlayView,
    ExploreChannelGroupsView,
    MotdAlertView,
    anonHomepageTemplate
) {
    'use strict';

    /**
     * Expects a collection of channels to explore.
     */
    var AnonHomepageView = Marionette.ItemView.extend({
        template: anonHomepageTemplate,

        regions: {
            marketingRegion: '[data-role=marketing-module]',
            overlayRegion: '[data-role=overlay]',
            contentRegion: '[data-role=content-area]',
            channelsModuleRegion: '[data-role=channels-module]',
            motdAlertRegion: '[data-role=motd-alert]',
        },

        events: {
            'click [data-action=close-promotions]': 'closePromotions',
            'click [data-action~=close-marketing]': 'closeMarketing',
        },

        onRender: function () {
            this.activateRegion(this.marketingRegion, this.createHomepageMarketingView);
            this.activateRegion(this.overlayRegion, this.createOverlayView);
            this.activateRegion(this.contentRegion, this.createFeedView);
            this.activateRegion(this.motdAlertRegion, this.showMotdView);
        },

        createHomepageMarketingView: function () {
            return new HomepageMarketingView();
        },

        createOverlayView: function () {
            return new AnonHomepageOverlayView();
        },

        createFeedView: function () {
            var channelGroupTabs = exploreModuleConstants.TABS;

            return new ExploreChannelGroupsView({
                collection: this.collection,
                channelTabs: [channelGroupTabs.TOP, channelGroupTabs.POPULAR, channelGroupTabs.RECENT],
            });
        },

        showMotdView: function () {
            return new MotdAlertView({
                persistent: true,
            });
        },

        closeMarketing: function () {
            this.closeRegions([this.marketingRegion]);
        },

        /**
         * Hides and then closes all the views promoting home and signing
         * up so the user can view the feed behind.
         */
        closePromotions: function () {
            this.closeRegions([this.marketingRegion, this.overlayRegion]);
        },

        closeRegions: function (regions) {
            _.each(regions, function (region) {
                var view = region.currentView;
                if (!view)
                    return;

                view.close();
            });

            // Return to the top of the page since views are being hidden and
            // there is newly visible content which may be moving up or may
            // start above the current visible viewport. Animation duration
            // should match the duration of the promotional views' hiding.
            $('body').animate({ scrollTop: 0 }, 350);
        },
    });

    withSubviews.call(AnonHomepageView.prototype);

    return AnonHomepageView;
});

